import { Segment } from 'component/Space/Segment'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'

import { LengthUnit } from 'type/LengthUnit'

type Props = {
  unit: LengthUnit
}

function getLabel(unit: LengthUnit) {
  if (unit === 'cm') return i18n('Centimeters')
  if (unit === 'in') return i18n('Inches')
}

export const UnitButton = observer(({ unit }: Props) => {
  const { profile } = store
  const size = opt.stand ? 16 : opt.tsum ? 15 : 10

  const onClick = useLatestCallback(() => {
    profile.unit = unit
  })

  return <Segment active={profile.unit === unit} action={onClick}>
    <Typo size={size}>
      {getLabel(unit)}
    </Typo>
  </Segment>
})
